module.exports = __webpack_public_path__ + "static/media/window-data-icon.33e00618.svg";